import { FEED_TYPES } from '../hooks/notifications/useCombinedFeed';

const NORMALIZE_MAP = {
  lost: FEED_TYPES.LOST,
  found: FEED_TYPES.FOUND,
  psa: FEED_TYPES.PSA,
  petservice: FEED_TYPES.PET_SERVICE,
  lostanimal: FEED_TYPES.LOST,
  foundanimal: FEED_TYPES.FOUND,

  'lost pet': FEED_TYPES.LOST,
  'found pet': FEED_TYPES.FOUND,
  'pet service': FEED_TYPES.PET_SERVICE,
};

export const normalizePostType = (raw) => {
  if (!raw || typeof raw !== 'string') return null;
  const key = raw.trim().toLowerCase();
  return NORMALIZE_MAP[key] || null;
};

export default normalizePostType;
